import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Settings, DollarSign, Database, Sliders } from "lucide-react";

const configSections = [
  {
    title: "Matrices de Ajuste",
    description: "Configuración de normalización y castigos",
    icon: Sliders,
    color: "text-blue-500",
  },
  {
    title: "Reglas de Pricing",
    description: "Algoritmos de cotización automática",
    icon: DollarSign,
    color: "text-green-500",
  },
  {
    title: "Pasarelas de Pago",
    description: "Integración con sistemas de pago",
    icon: Database,
    color: "text-purple-500",
  },
  {
    title: "Parámetros del Sistema",
    description: "Configuraciones generales",
    icon: Settings,
    color: "text-orange-500",
  },
];

export function Configuracion() {
  return (
    <div className="px-6 pt-2 pb-6 lg:px-8 lg:pb-8 space-y-6">
      <div>
        <p className="text-muted-foreground mt-1">Mantenedor de matrices, pricing y pasarelas</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {configSections.map((section) => (
          <Card key={section.title} className="hover:border-primary/50 transition-colors">
            <CardHeader>
              <div className="flex items-center gap-3">
                <section.icon className={`h-8 w-8 ${section.color}`} />
                <div className="flex-1">
                  <CardTitle className="text-base">{section.title}</CardTitle>
                  <CardDescription>{section.description}</CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <Button variant="outline" className="w-full">Configurar</Button>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Configuraciones Avanzadas</CardTitle>
          <CardDescription>Ajustes técnicos del sistema</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {["Integración IA (API Keys)", "Notificaciones Email/WhatsApp", "Backup y Seguridad", "Logs del Sistema"].map((item) => (
              <div key={item} className="flex items-center justify-between border border-border rounded-lg p-3">
                <span className="font-medium text-sm">{item}</span>
                <Button size="sm" variant="outline">Gestionar</Button>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
